import { createSlice } from '@reduxjs/toolkit';
import { filter } from 'lodash';
// utils
import axios from '../../utils/axios';

// ----------------------------------------------------------------------

const initialState = {
  isLoading: false,
  error: false,
  orderList: [],
  order: ''
};

const slice = createSlice({
  name: 'order',
  initialState,
  reducers: {
    // START LOADING
    startLoading(state) {
      state.isLoading = true;
    },

    // HAS ERROR
    hasError(state, action) {
      state.isLoading = false;
      state.error = action.payload;
    },

    // GET ORDERS
    getOrderListSuccess(state, action) {
      state.isLoading = false;
      state.orderList = action.payload;
    },

    // GET PRODUCT
    getOrderSuccess(state, action) {
      state.isLoading = false;
      state.order = action.payload;
    },
    // DELETE PRODUCT
    deleteOrder(state, action) {
      state.orderList = filter(state.orderList, (order) => order.id !== action.payload);
    }
  }
});

// Reducer
export default slice.reducer;

// ----------------------------------------------------------------------

export function getOrders() {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await axios.get('/api/v1/order');
      dispatch(slice.actions.getOrderListSuccess(response.data));
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}

// ----------------------------------------------------------------------

export function getOrder(orderId) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await axios.get(`/api/v1/order/${orderId}`);
      dispatch(slice.actions.getOrderSuccess(response.data));
    } catch (error) {
      console.error(error);
      dispatch(slice.actions.hasError(error));
    }
  };
}

// ----------------------------------------------------------------------

export function deleteOrder(orderId) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await axios.delete(`/api/v1/order/${orderId}`);
      dispatch(slice.actions.deleteOrder(response.data.entityId));
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}

export function closeOrder(orderId) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      await axios.post(`/api/v1/order/${orderId}/close`);
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}

export function openOrder(orderId) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      await axios.post(`/api/v1/order/${orderId}/open`);
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}
